<template>
  <div class="coupons-tab">
    <h1>{{customer.isrd_nm?customer.isrd_nm:''}} Coupons</h1>

    <div class="filter-container">
      <div class="filter-box">
        <span class="label">Add Coupon</span>
        <div class="search-box flex">
          <v-select
            v-model="coupon_code"
            placeholder="Coupon Title - COUPONCODE"
            :list="useCouponList"
            :valueKey="'code'"
            labelKey="code"
          >
            <template #default="scope">
              <div class="send-info">
                <span class="info">
                  {{ couponTitle(scope.item.title) }} - {{scope.item.code}}
                </span>
              </div>
            </template>
          </v-select>
          <div class="add-margin">
            <v-button
              size="small"
              type="primary"
              @click="handlerAddUse"
            >Add</v-button>
          </div>
        </div>
      </div>
    </div>
    <div class="transparent">
      <div class="coupon-body">
        <div
          v-for="(item,index ) in tableData"
          :key="index"
          class="coupon-content"
          :class="select==index?'is-check-coupon':''"
          @click="handlerSelect(item,index)">
          <div>
            <span class="coupon-title">{{item.title}}</span>
            <span class="coupon-code">{{item.coupon_code}}</span>
            <div class="coupon-mark">
              <span>{{item.description}}</span>
            </div>
          </div>
          <div>
            <span>{{item.unlimited_users==0?'Once ':'Unlimited'}} uses</span>

            <div
              v-if="select==index"
              class="flex select-icon">
              <span>Selected</span>
              <i class="el-icon-check"></i>
            </div>
            <div
              v-else
              class="flex">
              <span>Expires {{handTime(item.end_time)}}</span>
            </div>

          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import dayjs from 'dayjs'
import MixinOptions from '@/mixins/options'
import {deleteUserCoupon, addUserCoupon,getCouponList,getQuoteCouponList} from '@/api/coupon'
import {mapState} from 'vuex'
import coupon from '@/store/coupon'
export default {
  name: 'CouponsTab',
  mixins: [MixinOptions],
  props: {
    customerId: [String, Number],
    isQuote:{
      type:Boolean,
      default:false
    },
    customer: {
      type: Object,
      default: () => ({})
    },
    orderId:[String, Number],
    product: [String, Number],
    classId: [String, Number],
  },
  data() {
    return {
      tableData: [],
      useCouponList:[],
      coupon_code:'',
      select:-1
    }
  },
  computed:{
    ...mapState('coupon', ['couponCode']),
    customer_id(){
      return this.customerId
    }
  },
  watch:{
    tableData:{
      immediate:true,
      handler(val){
        val.forEach((item,index)=>{
          if(this.couponCode==item.coupon_code){
            this.select = index
          }
          if(!this.couponCode)this.select =-1
        })
      }
    },
    couponCode:{
      immediate:true,
      handler(val) {
        if(!val)this.select =-1
        else {
          this.tableData.filter((item,index)=>{
            if(val==item.coupon_code){
              this.select = index
            }
          })
        }
      }
    },
    customerId:{
      immediate:true,
      deep:true,
      handler(val){
        if(this.isQuote){
          this.network().getQuoteCouponList()
        }
      }
    }

  },
  created() {
    this.network().getCouponList()
    this.network().getQuoteCouponList()
  },
  methods: {
    couponTitle(data){
      return data['en-US']
    },
    handlerDelete(coupon_id,index){
      this.network().deleteUserCoupon(coupon_id,index)
    },
    handTime(time){
      if(time){
        return  dayjs(time).format('DD MMM YYYY')
      }else return '-'
    },
    handlerAddUse(){
      this.network().addUserCoupon()
    },
    handlerSelect(item,index){
      if(this.hasDelete)
        return
      if(this.select==index){
        this.select =-1
        this.$emit('coupon',{})
      }else {
        this.select = index
        this.$emit('coupon',item)
      }

    },
    currentChange(page) {
      this.pageConfig.currentPage = page
      this.network().getQuoteCouponList()
    },
    network() {
      return {

        //删除用户优惠券
        deleteUserCoupon: async (params,index) => {
          const { data } = await deleteUserCoupon({
            user_id:this.customer_id,
            user_coupon_id:params
          })
          this.tableData.splice(index,1)
        },

        getQuoteCouponList:async ()=>{
          let {data} = await getQuoteCouponList({
            user_id:this.customer_id,
            product_id:this.product,
            class_id:this.classId
          })
          this.tableData = data
        },
        getCouponList:async ()=>{
          let {data} = await getCouponList({
            page: 1,
            size: 100,
            type:1,
          })
          this.useCouponList =data.data
        },
        //用户添加优惠券
        addUserCoupon: async () => {
          const { data } = await addUserCoupon({
            user_id:this.customer_id,
            coupon_code: this.coupon_code
          })
          this.network().getQuoteCouponList()
        },

      }
    }
  }
}
</script>
<style lang="scss" scoped>
.coupons-tab {
  position: relative;
  h1 {
    padding-bottom: 15px;
    color: #616266;
    font-size: 16px;
  }
  .filter-container {
    .filter-box {
      margin-bottom: 10px;
      .label {
        display: block;
        padding-bottom: 5px;
        font-size: 14px;
        font-weight: bold;
        .all {
          display: inline-block;
          padding-left: 15px;
          color: #409EFF;
          font-weight: 500;
          cursor: pointer;
        }
      }
      .search-box {
        width: 400px;
      }
      .quote-box {
        width: 300px;
      }
      .add-margin{
        margin-left: 16px;
      }
    }
  }
  .coupon-body{
    margin-top: 24px;
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    .coupon-content{
      background: #fff;
      padding: 16px;
      margin: 0 16px 16px 0;
      border-radius: 4px;
      width: 200px;
      height: 150px;
      border:1px solid #D1D5DA;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .coupon-title{
        color:#24292E;
        font-size:16px!important;
        font-weight: 600;
        text-overflow: ellipsis;
        word-break: break-word;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
      }
      .coupon-code{
        height: 18px;
        line-height: 18px;
        display: inline-block;
      }
      span{
        color: #6A737D;
        font-size: 12px;
      }
      .coupon-mark{
        margin-top: 5px;
        overflow: hidden;
        span{
          text-overflow: ellipsis;
          word-break: break-word;
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
        }
      }
      .flex{
        justify-content: space-between;
        .icon{
          color: #CB2431;
          font-size: 12px;
        }
      }
    }
    .is-check-coupon{
      border: 1px solid #28A745;
      .select-icon{
        color:#28A745;
        font-weight: bold;
      }
    }

  }
}
</style>
